<template>
    <header class="home-hero">
        <div class="home-hero__content">
            <h1 v-if="title" class="home-hero__title">
                {{ title }}
            </h1>

            <div
                v-if="description"
                class="home-hero__description"
                v-html="description"
            />
        </div>

        <DrawMarker
            class="home-hero__image"
            :image
            marker="1"
            loading="eager"
            fetchpriority="high"
            sizes="(min-width: 1300px) 620px, (min-width: 1024px) 35vw, (min-width: 500px) 450px, 80vw"
        />

        <CtaCards sticky class="cta-cards--default" />
    </header>
</template>

<script setup>
defineProps({
    image: {
        type: [Object, Array],
        default: null
    },
    title: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    }
});
</script>

<style lang="less" src="./HomeHero.less" />
